/* ********************************************
 * import
 * ****************************************** */
import {config} from "../config";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {isMobile} from "../utils/utils";

/* ********************************************
 * functions
 * ****************************************** */

// ===========================================
// scrollToSmooth
// スムーズなスクロールの処理
// ===========================================
export function scrollResetPosition(data) {
  const smoother = ScrollSmoother.get();

  // data-scroll-hash か #ハッシュのデータを取得
  const hash = data.trigger?.dataset?.scrollHash || window.location.hash;

  // 調整値の計算
  const header = document.querySelector('#header');
  const offset = header.clientHeight;  // スクロール位置の微調整  例）ヘッダーの高さ分下に下げる

  // hash先にページ内スクロール（即座）
  let target;
  if (hash !== undefined && hash !== null && hash !== '') {
    target = document.querySelector(hash);
    if (target) {
      const position = target.offsetTop - offset;
      if (config.enableScrollSmoother && !isMobile()) {
        smoother.scrollTop(position);
      } else {
        requestAnimationFrame(() => {
          window.scrollTo({
            left: 0,
            top: position,
            // behavior: "smooth",
          });
        });
      }
    } else {
      console.log('scrollResetPosition: scroll target not found.');
    }
  } else {
    // hashを持たない通常の遷移の場合、即座にページTOPにスクロール位置をリセットする
    if (config.enableScrollSmoother && !isMobile()) {
      smoother.scrollTop(0);
    } else {
      window.scrollTo(0, 0);
    }
  }

}
